import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { QuoteIcon } from "../utils/Images";

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding: 0px 112px 0px 112px;

  @media (max-width: 900px) {
    padding: 0px 56px 0px 56px;
  }
`;

const Title = styled.h2`
  font-size: 40px;
  font-weight: 700;
  color: #231d4f;
  margin-bottom: 16px;
  margin-top: 100px;

  @media (max-width: 800px) {
    font-size: 28px;
  }
  @media (max-width: 500px) {
    font-size: 22px;
  }
`;

const TestimonialCard = styled.div`
  padding: 24px;
  width: 70% !important;

  @media (max-width: 855px) {
    width: 85% !important;
  }
`;

const Quote = styled.p`
  color: #111827;
  font-weight: 500;
  font-size: 24px;

  @media (max-width: 655px) {
    font-size: 18px;
  }
`;

const Name = styled.h4`
  font-weight: 600;
  color: #111827;
  font-size: 16px;
  margin-top: 98px;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;

  @media (max-width: 532px) {
    flex-direction: column;
  }
`;

const Location = styled.p`
  color: #4b5563;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 0px;
`;

const Arrow = styled.div`
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  color: #000;

  &.prev {
    left: -50px;
    color: #000;
  }

  &.next {
    right: -50px;
  }
`;

const testimonials = [
  {
    quote:
      "As a caregiver at an assisted living facility, Sophie has been a true game-changer for our residents. Its daily calls provide meaningful conversations tailored to each individual, helping them feel more connected and valued. I’ve noticed a significant improvement in their overall mood and mental sharpness, thanks to the cognitive stimulation Sophie offers through engaging topics and activities. Even on busy days when I can’t give each resident my full attention, I know they’re receiving care and companionship that truly makes a difference in their well-being.",
    name: "ohn Alvarez",
    location: "Professional Caregiver, New York, NY",
  },
  {
    quote:
      "Sophie has completely transformed my grandmother’s life. She used to feel so alone, but now she looks forward to her daily calls and always has a smile after speaking with Sophie.",
    name: "Sarah Taparoff",
    location: "Granddaughter, Austin, TX",
  },
  {
    quote:
      "My father has always been a quiet man since the loss of our mom, but Sophie has helped him open up and share stories I haven’t heard before. It’s been amazing to see him so engaged and happy.",
    name: "Vanessa Park",
    location: "Daughter, Los Angeles, CA",
  },
  {
    quote:
      "Sophie feels like a true companion for my mother, offering someone to listen, chat, and brighten her day. What’s super reassuring is that I can access insights about their conversations and see tangible improvements in her mood and engagement over time. It’s a comforting way to stay connected and involved in her well-being, even from a distance. ",
    name: "Janika Chapman",
    location: "Family Member, Chicago, IL",
  },
];

const Carousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <Arrow className="prev">dsf</Arrow>,
    nextArrow: <Arrow className="next">❯</Arrow>,
  };

  return (
    <Container>
      <Title>What Our Users Are Saying.</Title>
      <img
        src={QuoteIcon}
        alt=""
        width={32}
        height={26}
        style={{ margin: "25px 0px 48px 0px" }}
      />
      <Slider {...settings}>
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index}>
            <Quote>“{testimonial.quote}”</Quote>
            <Name>
              {testimonial.name} <Location>{testimonial.location}</Location>
            </Name>
          </TestimonialCard>
        ))}
      </Slider>
    </Container>
  );
};

export default Carousel;
